import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
// Analytics initialization
/* eslint-disable */
import './analytics/myAccount.analytics.js';
/* eslint-disable */

import Cart from 'thd-cart-bindings';
import Carousel from 'thd-carousel';

import App from './components/app';
import configureStore from './store';

import '../public/scss/global-css.scss';

const store = configureStore();
const rootElement = document.getElementById('orders_root');
// For A/B testers for recommended items overlay from link.
window.tntExposedObjects = {};
window.tntExposedObjects['thd-cart-bindings'] =
  Cart || 'react unable to load atc npm module';
window.tntExposedObjects['thd-carousel'] =
  Carousel || 'react unable to load carousel npm module';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  rootElement
);
